import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { PostosListagemComponent } from '@shared/components/postos-listagem/postos-listagem.component';
import { CriarPostoComponent } from './criar-posto/criar-posto.component';

@Component({
  selector: 'app-postos',
  standalone: true,
  imports: [
    CommonModule,
    DrawerModule,
    
    PostosListagemComponent,
    CriarPostoComponent,
  ],
  template: `
    <div class="page-content">
      
      <app-postos-listagem
        mapaHeight="calc(100vh - 200px)"
        (novoPosto)="showCreateDrawer = true"
      />

      <p-drawer
        [(visible)]="showCreateDrawer"
        position="right"
        [modal]="true"
        [blockScroll]="true"
        header="Novo Posto"
        styleClass="posto-create-drawer"
      >
        <app-criar-posto
          *ngIf="showCreateDrawer"
          [drawerMode]="true"
          (closed)="showCreateDrawer = false"
          (saved)="onPostoSaved()"
        />
      </p-drawer>
    </div>
  `,
  styles: `
    :host ::ng-deep .posto-create-drawer {
      width: min(1180px, 97vw) !important;
      background: var(--sp-surface);
    }

    :host ::ng-deep .posto-create-drawer .p-drawer-header {
      padding: 1.1rem 1.25rem;
      border-bottom: 1px solid var(--sp-border);
    }

    :host ::ng-deep .posto-create-drawer .p-drawer-title {
      color: var(--sp-text);
      font-size: 1rem;
      font-weight: 700;
    }

    :host ::ng-deep .posto-create-drawer .p-drawer-content {
      padding: 1.25rem;
    }
  `,
})
export class PostosComponent {
  @ViewChild(PostosListagemComponent)
  private listagem?: PostosListagemComponent;

  showCreateDrawer = false;

  onPostoSaved(): void {
    this.showCreateDrawer = false;
    this.listagem?.load();
  }
}
